<template>
  <div class="product-desc">
    <section class="pfd">
      <div class="pfd__tag" :style="{'color': ActiveColor }">{{pfdTag}}</div>

      <h1 class="pfd__title heading--style" v-html="pfdTitle"/>

      <div class="pfd__desc rich-text" v-html="pfdDescription"/>
      <div class="ratingSection">
        <a href="#" @click.prevent="reviewTag" :class="isBazaarvoiceActivated === true ? '' : 'star-rating__caption' ">
          <div v-if="isBazaarvoiceActivated === true" >
            <div data-bv-show="rating_summary" :data-bv-product-id="productId"></div>
          </div>
          <div  v-else class="pfd__star-rating star-rating">
            <star-rating :increment="1" :max-rating="5" :inactive-color="InactiveColor" :active-color="ActiveColor" :border-color="ActiveColor" :border-width="1" :star-size="28" :rating="overallRating" :read-only="true" :show-rating="false" aria-hidden="true"/>
            <span class="pfd__star-rating--count">{{ StarRatingCount }}/5</span>
            <span class="pfd__star-rating--total">{{ StarRatingText }}</span>
          </div>
        </a>
      </div>
      <div class="mobile-slider">
        <slot/>
        <div class="pfd__options">
          <div class="pfd__options--select">
            <div class="pfd__options--select_capacity">
              <div class="pfd__options--select_capacity--text"> {{ capacityText }} </div>
              <volume-variant-v2
                :volumes="volumesDetail"
                legend-name="Volume"
                :aria-label="legendCurrentVolume"
                :sfccvolumesdetails="variantDetail"
                :productid="productIds"/>
            </div>
            <div class="pfd__options--select_color" v-if="colorList.length > 0">
              <div class="pfd__options--select_color--text"> {{ colorText }} </div>
              <color-variant-v2 a11y-close-panel-text= "panelText"
                                a11y-next-panel-text= "nextPanelText"
                                a11y-previous-panel-text= "previousPanelText"
                                :colors="colorList"
                                legend-name="Shade"
                                itemprop="color"
                                :productid="productIds"
                                :sfcccolorsdetails="colorsDetails"/>
            </div>
          </div>
        </div>
      </div>
      <div class="pfd__recommenations">
        <div class="pfd__recommenations--header">
          <div class="pfd__recommenations--header_icon">
            <img :src="recommendationIcon" alt="" >
          </div>
          <h2 class="pfd__recommenations--header_text" v-html="recommendationTitle"/>
        </div>
        <div class="pfd__recommenations--content">
          <ul class="pdf__recommenations--content_list">
            <li class="recommenations-list__item" v-for="(content, index) in recommendationList" :key="index"><div v-html="decodeHtml(content)"/> </li>
          </ul>
          <div class="pdf__recommenations--content_para" v-html="recommendationDisclaimer"/>
        </div>
      </div>

      <div class="pfd__options">
        <div class="pfd__options--select">
          <div class="pfd__options--select_capacity">
            <div class="pfd__options--select_capacity--text"> {{ capacityText }} </div>
            <volume-variant-v2
              :volumes="volumesDetail"
              legend-name="Volume"
              :aria-label="legendCurrentVolume"
              :sfccvolumesdetails="variantDetail"
              :productid="productIds"/>
          </div>
          <div class="pfd__options--select_color" v-if="colorList.length > 0">
            <div class="pfd__options--select_color--text"> {{ colorText }} </div>
            <color-variant-v2 a11y-close-panel-text= "panelText"
                              a11y-next-panel-text= "nextPanelText"
                              a11y-previous-panel-text= "previousPanelText"
                              :colors="colorList"
                              legend-name="Shade"
                              itemprop="color"
                              :productid="productIds"
                              :sfcccolorsdetails="colorsDetails"/>
          </div>
        </div>
      </div>
      <div v-if="!smallScreen" class="pfd__actions" id="showSticky">
        <lrp-retailer :data-variant-ean="dataVariantEan" :initial-data="initialData" :data-text-lable="dataTextLable" class="sticky__buynow-button"  :data-bynow-tagging="dataBynowTagging" :sticky-buynow-button="true" :product-des-button="true" :error-messgage="errorMessgage" :nav-tagging-label="navTaggingLabel" v-if="isLrpRetailerEnabled == true" :legend-current-volume="legendCurrentVolume" :page-category="pageCategory"></lrp-retailer>
        <buy-now :buynow-text="buyonlineText" :is-online="true" :product-ean="productEan" :product-id="productId" :product-name="productName" :legend-current-volume="legendCurrentVolume" :tag-event="true" v-if="isCommerceConnectorActivated === 'true'"/>
         <mikmak-module   v-if="isMikmakEnabled"  @update:productId="selectedProductId =  $event" :mikmak-widget-id="mikmakWidgetId"     :mikmak-sticky-button="mikmakStickyButton"     :label-text="labelText"     :product-id="selectedProductId"  :analytics-data="analyticsData" :mikmak-cart-tag="mikmakCartTag" :product-name="productName" >  </mikmak-module>
        <a v-if="getData.length >= 1 && isClickandCollectEnable && item.variantid === selectedVariant" v-for="(item,index) in getData" :key="index" :data-index="index" target="_blank" :href="item.pharmacylink" @click="clickandCollectTag()" class="pharmacyBtn sticky__clickandcollect">{{ clickCollectLabel }}</a>
        <a v-if="findPharmacyStatus" :href="findPharmacyLink" class="pharmacyBtn"  @click="productformacyTag"> {{ findPharmacyText }} </a>
      </div>
    </section>
  </div>


</template>

<script>
import ColorVariantV2 from '@Feature/ColorVariant-V2/code/Scripts/components/color-variant-v2';
import VolumeVariantV2 from '@Feature/VolumeVariant-V2/code/Scripts/components/volume-variant-v2';
import BuyNow from '@Feature/buynow/code/Scripts/components/buynow.vue';
import StarRating from 'vue-star-rating';
import { AnalyticsHandler } from '@Foundation/analyticsHandler';
import LrpRetailer from '@Feature/LrpRetailer/code/Scripts/components/lrp-retailer.vue';
import MikmakModule from '@Feature/MikmakModule/code/Scripts/components/mikmak-module';
import DdxWidget from '@Feature/DDX/code/Scripts/components/ddx.vue';


export default {
  name: 'product-description',
  components: {
    ColorVariantV2,
    VolumeVariantV2,
    BuyNow,
    StarRating,
    LrpRetailer,
    MikmakModule,
    DdxWidget,
  },
  props: {
    buyonlineText: { type: String, required: false, default: '' },
    findPharmacyText: { type: String, required: false, default: '' },
    colorText: { type: String, required: false, default: '' },
    capacityText: { type: String, required: false, default: '' },
    pfdTag: { type: String, required: false, default: '' },
    pfdTitle: { type: String, required: false, default: '' },
    pfdDescription: { type: String, required: false, default: '' },
    StarRatingText: { type: String, required: false, default: '' },
    StarRatingCount: { type: String, required: false, default: '' },
    InactiveColor: { type: String, required: true, default: '' },
    ActiveColor: { type: String, required: true, default: '' },
    AverageRating: { type: Number, required: true, default: 4 },
    recommendationTitle: { type: String, required: true, default: '' },
    recommendationDisclaimer: { type: String, required: true, default: '' },
    recommendationList: { type: Array, required: false, default: [], },
    variantDetail: { type: Array, required: false, default: [] },
    volumesDetail: { type: Array, required: false, default: [] },
    colorsDetails: { type: Array, required: false, default: [] },
    productIds: { type: Array, required: false, default: [] },
    colorList: { type: Array, required: false, default: [] },
    panelText: { type: String, required: false, default: '' },
    previousPanelText: { type: String, required: false, default: '' },
    nextPanelText: { type: String, required: false, default: '' },
    recommendationIcon: { type: String, required: false, default: '' },
    findPharmacyLink: { type: String, required: false, default: '' },
    hoverColor: { type: String, required: false, default: '' },
    totalCount: { type: String, required: false },
    productName: { type: String, required: false, default: '' },
    productId: { type: String, required: false, default: '' },
    productEan: { type: String, required: false, default: '' },
    isCommerceConnectorActivated: { type: String, required: false, default: '' },
    getData: { type: Array, required: false, default: [] },
    isClickandCollectEnable: { type: Boolean, required: false, default: false },
    dataVariantEan: { type: String, required: false, default: '' },
    initialData: { type: Object, required: false, default: [] },
    dataBynowTagging: { type: Object, required: false, default: [] },
    errorMessgage: { type: String, required: false, default: '' },
    dataTextLable: { type: String, required: false, default: '' },
    isLrpRetailerEnabled : { type: Boolean, required: false, default: '' },
    clickCollectLabel: { type: String, required: false, default: '' },
    findPharmacyStatus : { type: Boolean, required: false, default: '' },
    dataClickandCollectTagging: { type: Array, required: false, default: [] },
    isBazaarvoiceActivated: { type: Boolean, required: false,},
    navTaggingLabel: { type: [String, Array], required: false, default: '' },
    pageCategory: { type: String, required: false, default: 'page category' },
    legendCurrentVolume: {type: String, required: false, default: 'legend-volume current-volume'},
    isMikmakEnabled: { type: Boolean, required: false, default: '' },
    labelText: { type: String, required: false, default: '' },
    mikmakWidgetId: { type: String, required: false},
    mikmakStickyButton: { type: Boolean, required: false},
    analyticsData: { type: Object,  default: () => ({}), },
    mikmakCartTag: {
      type: Array,
      required: false,
      default: () => [],
    }, 
  },

  data() {
    return {
      overallRating: this.AverageRating,
      smallScreen: !window.matchMedia('(min-width: 1023px)').matches,
      selectedVariant: '',
      selectedProductId: this.productEan || '', 
    };
  },

  created() {
    document.documentElement.style.setProperty('--hover-color', this.hoverColor);
    document.documentElement.style.setProperty('--active-color', this.ActiveColor);
  },
  mounted() {
    this.selectedVariant = this.getData.length >= 1 ? this.getData[0].defaultvariantid : ''
  },
  destroyed() {
    document.documentElement.style.removeProperty('--hover-color');
    document.documentElement.style.removeProperty('--active-color');
  },

  methods: {
    setSelectedProductId(productIdvalue) {
      this.selectedProductId =  productIdvalue
    },
    clickandCollectTag(){
      AnalyticsHandler.pushDataLayer({ ...this.dataClickandCollectTagging[0].tagging});
    },
    productformacyTag() {
      AnalyticsHandler.pushDataLayer({
        'event': 'uaevent',
        'event_name': 'where_to_buy',
        'ecommerce': 'undefined',
        'eventCategory': 'Ecommerce',
        'eventAction': 'where to buy',
        'eventLabel': `${[this.productName]}::${[this.productEan]}`,
        'product_info': `${[this.productName]}::${[this.productEan]}`,
      });
    },

    reviewTag() {
      let url = window.location.href;
      let res = url.split("#");
      let hash = res[1];
      if(!hash) {
        window.location = url+'#ratings';
      }else{
        window.location = url;
      }
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  },
};
</script>

<style lang="scss" src="./product-description.scss"></style>
